<template>
  <div>
    <h5>
      Progress Report:
      <span class="mr-1 badge badge-dark">
        Progress:
        <b>{{ reportStats.succeeded + reportStats.failed }}/{{ total }}</b>
      </span>
      <span
        v-for="(count, status) in reportStats"
        :class="
          [
            'status-badge',
            'mr-1',
            'badge',
            `badge-${statusTagTypes[status]}`,
          ].join(' ')
        "
        :key="status"
      >
        {{ status }}:
        <b>{{ count }}</b>
      </span>
    </h5>
    <div class="progress">
      <div
        v-for="(count, status) in reportStats"
        :key="status"
        :class="['progress-bar', `bg-${statusTagTypes[status]}`].join(' ')"
        :style="`width: ${(count / total) * 100}%`"
        :aria-valuenow="(count / total) * 100"
        aria-valuemin="0"
        aria-valuemax="100"
        role="progressbar"
      ></div>
    </div>
  </div>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';
import '@tradeshift/elements.spinner';
import '@tradeshift/elements.button';
import '@tradeshift/elements.status';

export default {
  components: {},
  props: {
    reportStats: {
      type: Object,
      default() {
        return {};
      },
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      statusTagTypes: {
        succeeded: 'success',
        failed: 'danger',
        'in progress': 'primary',
      },
    };
  },
};
</script>

<style scoped>
.status-badge {
  text-transform: capitalize;
}

.progress {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 5px;
}
</style>
